module.exports = "https://cdn.realtymogul.com/static/media/mogulreitii.d8a938c6.m4v";